// loanSearchProductSlice.js
import {createSlice} from '@reduxjs/toolkit';

const loanSearchProductSlice = createSlice({
  name: 'loanSearchProduct',
  initialState: {
    loanProduct: {},
    rbackKey: '',
  },
  reducers: {
    setLoanProductValue: (state, action) => {
      state.loanProduct = action.payload;
    },
    setRbackKey: (state, action) => {
      state.rbackKey = action.payload;
    },
    clearLoanProductValue: state => {
      state.loanProduct = {};
      state.rbackKey = '';
    },
  },
});

export const {setLoanProductValue, clearLoanProductValue, setRbackKey} =
  loanSearchProductSlice.actions;
export default loanSearchProductSlice.reducer;
